import { CheckExistingGame } from './application/check-existing-game.use-case';
import { GameState } from './application/game.state.svelte';
import { LocalStorageGameAdapter } from './infrastructure/adapters/local-storage-game.adapter';

const storageAdapter = new LocalStorageGameAdapter();

export const useCases = {
	checkExistingGame: new CheckExistingGame(storageAdapter)
};

export const gameState = new GameState(storageAdapter);
